import React from 'react'
import { RouteProps } from 'react-router-dom'

import SuccessTemplate from '../../../../templates/Success'

import { useModifySuccessProps } from './useProps'

const ModifySuccessPage: React.FC<RouteProps> = () => {
  const templateProps = useModifySuccessProps()

  return <SuccessTemplate {...templateProps} />
}

export default ModifySuccessPage
